import React, { Component } from 'react';
import Timer from 'react-compound-timer';
import Countdown, { zeroPad } from 'react-countdown';
import FlipClockCountdown from '@leenguyen/react-flip-clock-countdown';
import '@leenguyen/react-flip-clock-countdown/dist/index.css';
import styled from 'styled-components';
import './index.css';

const TimerOptionsDiv = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-weight: 600;
  background-color: transparent;
  font-size: ${(props) => props.specialOffer && '24px'};
  line-height: ${(props) => (props.specialOffer ? 'normal' : props.noLineHeight ? 'normal' : '')};
  border-radius: 4px;
`;

const TimerOptionsName = styled.p`
  font-size: 14px;
  font-weight: 400;
  line-height: ${(props) => props.specialOffer && 'normal'};
  color: ${({ timerBg }) => timerBg && '#fff'}};
`;

const CustomTimerOptionsDiv = styled.div`
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  font-size: inherit;
  line-height: ${({ noLineHeight }) => noLineHeight && 'normal'};
`;
const CustomTimerDigits = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: inherit;
  line-height: ${({ noLineHeight }) => noLineHeight && 'normal'};
  min-width: 44px;
  padding: 4px 4px;
  color: ${({ timerBg }) => (timerBg === 'light' ? 'var(--normalTxtColor)' : 'var(--dark)')};
  background-color: ${({ timerBg }) => (timerBg === 'light' ? '#fff' : 'transparent')};
  border-radius: 4px;
`;
const CustomTimerColon = styled.div`
  color: ${({ timerBg }) => timerBg === 'light' && '#fff'};
  font-size: ${({ colonSize }) => colonSize && colonSize};
`;

/**
**Reset countdown for each three days
const DIFF_DATE = 3;
const START_DATE = new Date().getDate() % DIFF_DATE;
state = {
    date : START_DATE === 0 ? new Date(`2020-01-${new Date().getDate()+DIFF_DATE}T00:00:00`) : new Date(`2020-01-${new Date().getDate()+(DIFF_DATE-START_DATE)}T00:00:00`)
}
**/

export class OfferCountdown extends Component {
  state = {
    date: new Date(this.props.expiresAt),
  };

  render() {
    return (
      <Countdown
        date={this.state.date}
        zeroPadTime={2}
        zeroPadDays={2}
        renderer={({ days, hours, minutes, seconds }) => (
          <span>
            {' '}
            {zeroPad(hours)}h {zeroPad(minutes)}m {zeroPad(seconds)}s{' '}
          </span>
        )}
      />
    );
  }
}

export const OfferTimer = ({ specialOffer, dayCount, colonSize, noLineHeight, tempTimer, type, timerBg }) => {
  const TODAY = new Date().getDate();
  let endDate;
  if (dayCount === 1) {
    endDate = new Date();
    endDate.setDate(TODAY);
    endDate.setHours(23);
    endDate.setMinutes(59);
    endDate.setSeconds(59);
    endDate = Math.floor(endDate / 1000);
  } else {
    if (TODAY % 2 === 0) {
      endDate = new Date();
      endDate.setDate(TODAY + 1);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      endDate = Math.floor(endDate / 1000);
    } else {
      endDate = new Date();
      endDate.setDate(TODAY);
      endDate.setHours(23);
      endDate.setMinutes(59);
      endDate.setSeconds(59);
      endDate = Math.floor(endDate / 1000);
    }
  }

  const CURRENT_DATE = Date.now();
  const COVID19 = endDate * 1000 - CURRENT_DATE;

  // temporary (only till Diwali)
  const currentDate = Date.now();
  let targetDate = new Date();
  targetDate.setDate(10);
  targetDate.setHours(23);
  targetDate.setMinutes(59);
  targetDate.setSeconds(59);
  targetDate = Math.floor(targetDate / 1000);

  const timeDifference = targetDate * 1000 - currentDate;

  if (type === 'individuals-buy-page') {
    return (
      <Timer initialTime={tempTimer ? timeDifference : COVID19} direction="backward" formatValue={(value) => String(value).padStart(2, '0')}>
        <CustomTimerOptionsDiv timerBg={timerBg} noLineHeight={noLineHeight}>
          <CustomTimerDigits timerBg={timerBg} noLineHeight={noLineHeight}>
            <Timer.Days />
          </CustomTimerDigits>
          <TimerOptionsName timerBg={timerBg}>day</TimerOptionsName>
        </CustomTimerOptionsDiv>
        <CustomTimerColon timerBg={timerBg} colonSize={colonSize}>
          :
        </CustomTimerColon>
        <CustomTimerOptionsDiv timerBg={timerBg} noLineHeight={noLineHeight}>
          <CustomTimerDigits timerBg={timerBg} noLineHeight={noLineHeight}>
            <Timer.Hours />
          </CustomTimerDigits>
          <TimerOptionsName timerBg={timerBg}>hrs</TimerOptionsName>
        </CustomTimerOptionsDiv>
        <CustomTimerColon timerBg={timerBg} colonSize={colonSize}>
          :
        </CustomTimerColon>
        <CustomTimerOptionsDiv timerBg={timerBg} noLineHeight={noLineHeight}>
          <CustomTimerDigits timerBg={timerBg} noLineHeight={noLineHeight}>
            <Timer.Minutes />
          </CustomTimerDigits>
          <TimerOptionsName timerBg={timerBg}>mins</TimerOptionsName>
        </CustomTimerOptionsDiv>
        <CustomTimerColon timerBg={timerBg} colonSize={colonSize}>
          :
        </CustomTimerColon>
        <CustomTimerOptionsDiv timerBg={timerBg} noLineHeight={noLineHeight}>
          <CustomTimerDigits timerBg={timerBg} noLineHeight={noLineHeight}>
            <Timer.Seconds />
          </CustomTimerDigits>
          <TimerOptionsName timerBg={timerBg}>secs</TimerOptionsName>
        </CustomTimerOptionsDiv>
      </Timer>
    );
  } else {
    return (
      <Timer initialTime={tempTimer ? timeDifference : COVID19} direction="backward">
        <TimerOptionsDiv specialOffer={specialOffer} noLineHeight={noLineHeight}>
          <Timer.Days />
          <TimerOptionsName specialOffer={specialOffer}>day</TimerOptionsName>
        </TimerOptionsDiv>
        <div style={{ fontSize: colonSize }}>:</div>
        <TimerOptionsDiv specialOffer={specialOffer} noLineHeight={noLineHeight}>
          <Timer.Hours />
          <TimerOptionsName specialOffer={specialOffer}>hrs</TimerOptionsName>
        </TimerOptionsDiv>
        <div style={{ fontSize: colonSize }}>:</div>
        <TimerOptionsDiv specialOffer={specialOffer} noLineHeight={noLineHeight}>
          <Timer.Minutes />
          <TimerOptionsName specialOffer={specialOffer}>mins</TimerOptionsName>
        </TimerOptionsDiv>
        <div style={{ fontSize: colonSize }}>:</div>
        <TimerOptionsDiv specialOffer={specialOffer} noLineHeight={noLineHeight}>
          <Timer.Seconds />
          <TimerOptionsName specialOffer={specialOffer}>secs</TimerOptionsName>
        </TimerOptionsDiv>
      </Timer>
    );
  }
};

export const FlipOfferTimer = ({ type, variant, courseTheme, dayCount, offerEndTime }) => {
  let now = new Date();
  let endDate = new Date();

  endDate.setDate(now.getDate() + (now.getDate() % 2 === 0)); // Add 1 if today is even
  if (offerEndTime && new Date(offerEndTime) >= now) endDate = new Date(offerEndTime);
  if (dayCount === 1) endDate = new Date(new Date().setHours(23, 59, 59, 999));

  endDate.setHours(23, 59, 59, 999); // Set time to 23:59:59.999
  const TimeLeft = endDate.getTime(); // Get timestamp in milliseconds

  if (type === 'dboard-prime-bar') {
    let courseThemeBgClass = '';
    if (courseTheme === 'partner-plus') courseThemeBgClass = 'partner-timer-bg';
    if (courseTheme === 'code-juniors') courseThemeBgClass = 'juniors-timer-bg';
    if (courseTheme === 'regionals') courseThemeBgClass = 'regionals-timer-bg';
    if (courseTheme === 'default') courseThemeBgClass = 'originals-timer-bg';

    return (
      <FlipClockCountdown
        to={TimeLeft}
        hideOnComplete={false}
        className={`dboard-flip-clock ${variant === 'originals' ? 'dark-label-text' : variant === 'regionals' ? 'light-bg-clock' : courseTheme ? courseThemeBgClass : ''}`}
        showSeparators={false}
      />
    );
  }
  if (type === 'header-prime-bar') {
    return (
      <FlipClockCountdown
        to={TimeLeft}
        hideOnComplete={false}
        className={`header-flip-clock ${variant === 'white-lbl' ? 'light-label-text' : variant === 'light-bg-clock' ? 'light-bg-clock' : ''}`}
        showSeparators={false}
      />
    );
  }
  if (type === 'pricing-page-timer') {
    // let variantBgClass = '';
    // if (variant === 'partner-plus') variantBgClass = 'partner-timer-bg';
    // if (variant === 'code-juniors') variantBgClass = 'juniors-timer-bg';
    // if (variant === 'regionals') variantBgClass = 'regionals-timer-bg';

    return <FlipClockCountdown to={TimeLeft} hideOnComplete={false} className={`pricing-page-flip-clock`} showSeparators={false} />;
  }
};
